import React, { Component } from 'react';
import {Bar} from 'react-chartjs-2';
import ChartDataLabels from "chartjs-plugin-datalabels";
import Chart from 'chart.js/auto';



class BarChart extends Component {
  constructor(props) {
    super(props);
   
   this.state = 
    {
      labels: [],
      datasets:[]
    }
  
  }

barChartFunctionalData(){
  let mainData=this.props.data
  let labels=this.props.label
  let bgcolor= ['#004876','#ec6607','#e20c18','#666','#844f38','#171815']
  let label=this.props.title
  let bgcolor1=bgcolor.slice(0,label.length)
  let data= []
  bgcolor1.map((val,index)=>
  data.push({
    
    label: label[index],
    fill: false,
    lineTension: 0.5,
    backgroundColor: bgcolor1[index],
    borderColor: bgcolor1[index],
    borderWidth: 2,
    data: mainData[index]
  })


  )

  this.setState({
    labels:labels,
    datasets:data
   })
}

  componentDidMount(){
    this.barChartFunctionalData()
  }
  componentDidUpdate(prevProps) {
     
    if ((prevProps.data !== this.props.data) && (prevProps.label !== this.props.label)) {
      this.barChartFunctionalData()
    }
   
  }
  
    render() {
        return (
          <>
            <Bar
              data={this.state}
              width={400}
              height={200}
              options={
                {
                plugins: {
                datalabels: {
                   display: true,
                 
                   color:'white',
                   formatter: function(value, index, values) {
                    if(value >0 ){
                        value = value.toString();
                        value = value.split(/(?=(?:...)*$)/);
                        value = value.join(',');
                        return value;
                    }else{
                        value = "";
                        return value;
                    }
                }
            },
            legend: {
              display: true,
              position: 'top'
            },
            title: {
              display: true,
              text: this.props.mainTitle,
              font: {
                size: 20
              }
              },
                
             },
             scales: {
              x: {
             
              },
              y: {
                ticks: {
                  beginAtZero: true,
                },
               
              },
            },
             
                
              }}
              plugins={[ChartDataLabels]}
            />
          </>
        );
    }
}

export default BarChart;